<template>
  <ModalComponent :modal-style="'max-width: 745px'" @close="emit('close')">
    <template #header>
      <slot name="header" />
    </template>

    <slot />

    <template v-if="prompt">
      <div>
        {{ appTranslate('Confirm you want to %s by typing', [appTranslate(prompt.action, undefined, 'lowercase')]) }}
        <strong>
          {{ prompt.confirmString }}
        </strong>
      </div>

      <input
        v-model="promptModel"
        type="text"
        class="form-control"
        :class="{ required: prompt.confirmString !== promptModel }"
        :placeholder="prompt.confirmString"
      />
      <small v-if="prompt.confirmString !== promptModel" class="text-danger">
        <i class="fa fa-exclamation-circle mr-1" />
        <template v-if="!promptModel"> {{ appTranslate('Required') }} </template>
        <template v-else> {{ appTranslate('Your input is does not match the required word') }} </template>
      </small>
    </template>

    <div class="d-flex mt-2 justify-content-end" style="gap: 0.25rem">
      <button type="button" class="btn btn-outline-danger" @click="emit('close')">{{ appTranslate('Cancel') }}</button>

      <ActionPendingButton
        class="btn btn-primary"
        :disabled="!!(prompt?.confirmString && promptModel !== prompt.confirmString)"
        :pending="pending"
        variant="danger"
        @click="submit()"
      >
        {{ appTranslate('Delete') }}
      </ActionPendingButton>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import { useTranslation } from '@/composables/useTranslation'
import { ref } from 'vue'
import ActionPendingButton from './ActionPendingButton.vue'
import ModalComponent from './ModalComponent.vue'

defineProps<{ prompt?: { confirmString: string; action: 'delete' } }>()
const emit = defineEmits(['confirm', 'close'])

const { appTranslate } = useTranslation()

const promptModel = ref('')
const pending = ref(false)

const submit = () => {
  emit('confirm')
  pending.value = true
}
</script>

<style lang="scss" scoped>
.required {
  border-color: red;

  &:focus {
    box-shadow: 0 0 0 0.2rem #f003;
  }
}
</style>
